import { type MissingAssetsList, missingAssetsListSchema } from '@xphoto/shared';
import { ApiError } from '../gallery/api';
import { apiFetch } from '../lib/http';

/**
 * Client typé des FICHIERS ABSENTS (audit de remédiation, A5). Comme les autres clients,
 * la réponse est RE-PARSÉE par son schéma partagé `@xphoto/shared`.
 *
 * Une seule route est nécessaire : la LECTURE. La mise à la corbeille réutilise
 * `softDeleteAssets` (`trash/trash-api.ts`) et la purge définitive l'onglet « Poubelle ».
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      // Corps non-JSON : on garde le code générique.
    }
    throw new ApiError(res.status, code);
  }
  return res.json();
}

/**
 * `GET /api/libraries/:id/missing-assets?limit=&offset=` — page de médias dont le
 * fichier a disparu du disque, + total. Réservé à l'écriture côté serveur (403 pour un
 * bénéficiaire en lecture seule).
 */
export async function fetchMissingAssets(
  libraryId: string,
  limit: number,
  offset: number,
): Promise<MissingAssetsList> {
  const sp = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  const res = await apiFetch(`/api/libraries/${libraryId}/missing-assets?${sp.toString()}`);
  return missingAssetsListSchema.parse(await readJson(res));
}
